const sanitizeBaseUrl = (raw?: string | null) => {
  if (!raw) return '';
  return raw.replace(/\/+$/, '');
};

const resolveBackendUrl = () => {
  const explicit = process.env.REACT_APP_BACKEND_API_URL || process.env.REACT_APP_BACKEND_URL;
  if (explicit) return sanitizeBaseUrl(explicit);
  const apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl) return sanitizeBaseUrl(apiUrl.replace(/\/api\/?$/, ''));
  return '';
};

const BACKEND_URL = resolveBackendUrl();

const buildSettingsUrl = () => (BACKEND_URL ? `${BACKEND_URL}/api/user/settings` : '/api/user/settings');

export interface UserSettings {
  id?: number;
  userId?: number;
  timezone?: string;
  language?: string;
  theme?: 'light' | 'dark' | 'system';
  pushEnabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const getUserSettings = async (): Promise<UserSettings | null> => {
  try {
    const response = await fetch(buildSettingsUrl(), {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) {
      return null;
    }

    const settings = await response.json();
    return settings;
  } catch (error) {
    console.error('Failed to fetch user settings:', error);
    return null;
  }
};

export const updateUserSettings = async (
  settings: Partial<UserSettings>
): Promise<UserSettings | null> => {
  try {
    const response = await fetch(buildSettingsUrl(), {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(settings),
    });

    if (!response.ok) {
      return null;
    }

    const updated = await response.json();
    return updated;
  } catch (error) {
    console.error('Failed to update user settings:', error);
    return null;
  }
};

export const saveThemePreference = async (theme: 'light' | 'dark' | 'system') => {
  return updateUserSettings({ theme });
};

export const saveLanguagePreference = async (language: string) => {
  return updateUserSettings({ language });
};
